import React, { useState, useEffect } from "react";
import api from "../services/api";

const Movimientos = () => {
  const [movimientos, setMovimientos] = useState([]);
  const [movimientosFiltrados, setMovimientosFiltrados] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [filtroTipo, setFiltroTipo] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const [filtroFecha, setFiltroFecha] = useState("");

  useEffect(() => {
    obtenerMovimientos();
  }, []);

  useEffect(() => {
    aplicarFiltros();
  }, [movimientos, filtroTipo, busqueda, filtroFecha]);

  const obtenerMovimientos = async () => {
    try {
      setCargando(true);
      const res = await api.get("/movimientos");
      setMovimientos(res.data);
    } catch (error) {
      console.error("Error al obtener movimientos:", error);
    } finally {
      setCargando(false);
    }
  };

  const aplicarFiltros = () => {
    let resultado = [...movimientos];

    // Filtrar por tipo
    if (filtroTipo) {
      resultado = resultado.filter((m) => m.tipo === filtroTipo);
    }

    // Filtrar por búsqueda
    if (busqueda) {
      resultado = resultado.filter((m) =>
        m.Material?.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
        m.Material?.codigo?.toLowerCase().includes(busqueda.toLowerCase()) ||
        m.usuario?.toLowerCase().includes(busqueda.toLowerCase())
      );
    }

    // Filtrar por fecha
    if (filtroFecha) {
      resultado = resultado.filter((m) => {
        const fechaMov = new Date(m.fecha).toISOString().split('T')[0];
        return fechaMov === filtroFecha;
      });
    }

    setMovimientosFiltrados(resultado);
  };

  const limpiarFiltros = () => {
    setFiltroTipo("");
    setBusqueda("");
    setFiltroFecha("");
  };

  // Calcular estadísticas
  const totalEntradas = movimientos.filter(m => m.tipo === "entrada").length;
  const totalSalidas = movimientos.filter(m => m.tipo === "salida").length;
  const cantidadEntradas = movimientos
    .filter(m => m.tipo === "entrada")
    .reduce((acc, m) => acc + (m.cantidad || 0), 0);
  const cantidadSalidas = movimientos
    .filter(m => m.tipo === "salida")
    .reduce((acc, m) => acc + (m.cantidad || 0), 0);



function formatearSoloFechaSinDesfase(fechaISO) {
  if (!fechaISO) return "N/A";

  const [year, month, day] = fechaISO.split("-");
  return `${day}/${month}/${year}`;
}
    

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>📊 Historial de Movimientos</h1>
          <p style={styles.subtitle}>Registro completo de entradas y salidas</p>
        </div>
      </div>

      {/* Estadísticas */}
      <div style={styles.statsGrid}>
        <div style={styles.statCard}>
          <div style={{...styles.statIcon, background: '#10b981'}}>📥</div>
          <div style={styles.statContent}>
            <div style={styles.statNumber}>{totalEntradas}</div>
            <div style={styles.statLabel}>Entradas</div>
            <div style={styles.statSubtext}>{cantidadEntradas.toFixed(2)} unidades</div>
          </div>
        </div>

        <div style={styles.statCard}>
          <div style={{...styles.statIcon, background: '#ef4444'}}>📤</div>
          <div style={styles.statContent}>
            <div style={styles.statNumber}>{totalSalidas}</div>
            <div style={styles.statLabel}>Salidas</div>
            <div style={styles.statSubtext}>{cantidadSalidas.toFixed(2)} unidades</div>
          </div>
        </div>

        <div style={styles.statCard}>
          <div style={{...styles.statIcon, background: '#3b82f6'}}>📋</div>
          <div style={styles.statContent}>
            <div style={styles.statNumber}>{movimientos.length}</div>
            <div style={styles.statLabel}>Total Movimientos</div>
            <div style={styles.statSubtext}>Historial completo</div>
          </div>
        </div>

        <div style={styles.statCard}>
          <div style={{...styles.statIcon, background: '#8b5cf6'}}>⚖️</div>
          <div style={styles.statContent}>
            <div style={{...styles.statNumber, fontSize: '20px'}}>
              {(cantidadEntradas - cantidadSalidas).toFixed(2)}
            </div>
            <div style={styles.statLabel}>Balance Neto</div>
            <div style={styles.statSubtext}>Diferencia E-S</div>
          </div>
        </div>
      </div>

      {/* Filtros */}
      <div style={styles.filtersCard}>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>🔍 Buscar:</label>
          <input
            type="text"
            style={styles.searchInput}
            placeholder="Material, código o usuario..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />
        </div>

        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>📊 Tipo:</label>
          <select
            style={styles.filterSelect}
            value={filtroTipo}
            onChange={(e) => setFiltroTipo(e.target.value)}
          >
            <option value="">Todos</option>
            <option value="entrada">Entradas</option>
            <option value="salida">Salidas</option>
          </select>
        </div>

        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>📅 Fecha:</label>
          <input
            type="date"
            style={styles.filterDate}
            value={filtroFecha}
            onChange={(e) => setFiltroFecha(e.target.value)}
          />
        </div>

        {(filtroTipo || busqueda || filtroFecha) && (
          <button style={styles.btnClear} onClick={limpiarFiltros}>
            ✕ Limpiar
          </button>
        )}

        <div style={styles.filterStats}>
          <span style={styles.statsText}>
            Mostrando {movimientosFiltrados.length} de {movimientos.length}
          </span>
        </div>
      </div>

      {/* Tabla */}
      <div style={styles.tableCard}>
        <h3 style={styles.cardTitle}>📋 Registro de Movimientos</h3>
        
        {cargando ? (
          <div style={styles.loadingContainer}>
            <p style={styles.loadingText}>Cargando movimientos...</p>
          </div>
        ) : movimientosFiltrados.length === 0 ? (
          <div style={styles.emptyState}>
            <span style={styles.emptyIcon}>📭</span>
            <p style={styles.emptyText}>
              {movimientos.length === 0 
                ? "No hay movimientos registrados" 
                : "No se encontraron movimientos con los filtros aplicados"}
            </p>
          </div>
        ) : (
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>ID</th>
                  <th style={styles.th}>Tipo</th>
                  <th style={styles.th}>Material</th>
                  <th style={styles.th}>Cantidad</th>
                  <th style={styles.th}>Usuario</th>
                  <th style={styles.th}>Observaciones</th>
                  <th style={styles.th}>Fecha</th>
                </tr>
              </thead>
              <tbody>
                {movimientosFiltrados.map((mov) => (
                  <tr 
                    key={mov.id}
                    style={styles.tr}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                  >
                    <td style={styles.td}>#{mov.id}</td>
                    <td style={styles.td}>
                      <span style={{
                        ...styles.badge,
                        ...(mov.tipo === "entrada" ? styles.badgeEntrada : styles.badgeSalida)
                      }}>
                        {mov.tipo === "entrada" ? "📥 ENTRADA" : "📤 SALIDA"}
                      </span>
                    </td>
                    <td style={styles.td}>
                      <div style={styles.materialInfo}>
                        <strong>{mov.Material?.codigo || "N/A"}</strong>
                        <span style={styles.materialName}>{mov.Material?.nombre || "Sin nombre"}</span>
                      </div>
                    </td>
                    <td style={{...styles.td, fontWeight: 'bold', textAlign: 'right'}}>
                      {mov.cantidad || 0}
                    </td>
                   <td style={styles.td}>{mov.usuario || "Sistema"}</td>

<td style={styles.td}>
    {mov.observaciones && mov.observaciones.trim() !== ""
        ? mov.observaciones.length > 30
            ? mov.observaciones.substring(0, 30) + "..."
            : mov.observaciones
        : "Sin observación"}
</td>
<td style={styles.td}>
  <div style={styles.dateInfo}>
   <span style={styles.dateDay}>
{formatearSoloFechaSinDesfase(mov.fecha)}
</span>
   
  </div>
</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f8fafc',
    padding: '20px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '25px',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 5px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: '0',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
    marginBottom: '25px',
  },
  statCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
  },
  statIcon: {
    width: '50px',
    height: '50px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    color: 'white',
  },
  statContent: {
    flex: '1',
  },
  statNumber: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#1e293b',
    marginBottom: '4px',
  },
  statLabel: {
    fontSize: '12px',
    color: '#64748b',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  statSubtext: {
    fontSize: '11px',
    color: '#94a3b8',
    marginTop: '2px',
  },
  filtersCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
    display: 'flex',
    gap: '15px',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flex: '1',
    minWidth: '200px',
  },
  filterLabel: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#475569',
    whiteSpace: 'nowrap',
  },
  searchInput: {
    flex: '1',
    padding: '8px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
  },
  filterSelect: {
    flex: '1',
    padding: '8px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
    background: 'white',
    cursor: 'pointer',
  },
  filterDate: {
    flex: '1',
    padding: '8px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
  },
  btnClear: {
    padding: '8px 16px',
    background: '#94a3b8',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  filterStats: {
    padding: '8px 16px',
    background: '#f1f5f9',
    borderRadius: '8px',
  },
  statsText: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
  },
  tableCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '25px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '20px',
  },
  loadingContainer: {
    padding: '40px',
    textAlign: 'center',
  },
  loadingText: {
    color: '#64748b',
    fontSize: '14px',
  },
  emptyState: {
    padding: '60px 20px',
    textAlign: 'center',
  },
  emptyIcon: {
    fontSize: '64px',
    marginBottom: '15px',
    display: 'block',
    opacity: '0.5',
  },
  emptyText: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#475569',
    margin: '0',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
  },
  th: {
    background: '#f8fafc',
    padding: '12px',
    textAlign: 'left',
    fontWeight: '700',
    color: '#475569',
    borderBottom: '2px solid #e2e8f0',
    whiteSpace: 'nowrap',
  },
  tr: {
    transition: 'background 0.2s ease',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #f1f5f9',
    color: '#1e293b',
  },
  badge: {
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
  },
  badgeEntrada: {
    background: '#d1fae5',
    color: '#065f46',
  },
  badgeSalida: {
    background: '#fee2e2',
    color: '#991b1b',
  },
  materialInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  materialName: {
    fontSize: '12px',
    color: '#64748b',
  },
  dateInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  dateDay: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#1e293b',
  },
  dateTime: {
    fontSize: '11px',
    color: '#94a3b8',
  },
};

export default Movimientos;